/** @format */

import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";

const SharedLayout = () => {

  const location = useLocation();
  const excludedPaths = [
    "/CreateModelStep1",
    "/CreateModelStep2",
    "/CreateModelStep3",
    "/CreateModelStep3_0",
    "/CreateModelStep4",
    "/CreateModelStep5",
  ];

  const isSidebarVisible = !excludedPaths.includes(location.pathname);
 

  return (
    <div className="flex flex-col md:flex-row">
      {isSidebarVisible && (
        <div className=" md:w-auto">
          <Sidebar/>
        </div>
      )}
      <div className="flex-1">
            <Outlet  />
      </div>
    </div>
  );
};

export default SharedLayout;
